import React from 'react';
import { Box, Grid, Typography, TextField, Button, Snackbar, useTheme, useMediaQuery } from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';

const SubscriptionForm = () => {
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const formik = useFormik({
    initialValues: {
      name: '',
      email: '',
    },

    validationSchema: Yup.object({
      name: Yup.string().required('Name is required'),
      email: Yup.string().email('Invalid email address').required('Email is required'),
    }),
    onSubmit: (values, { resetForm }) => {
      // Placeholder for API call to subscribe to the newsletter
      // You should replace the URL and method according to your actual API
      fetch('https://your-api-endpoint.com/newsletter', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
      })
        .then((response) => {
          if (response.ok) {
            setOpen(true);
            resetForm();
          } else {
            alert('Failed to subscribe');
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          alert('Error submitting form');
        });
    },
  });

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const maxWidth = theme.breakpoints.values.md;

  const textFieldStyle = {
    bgcolor: 'background.paper',
    color: 'text.primary',
    borderRadius: 1,
    '.MuiFormHelperText-root': {
      // fontWeight: 'bold',
      // color: '#d32f2f',
      m: 0,
      paddingLeft: '14px',
      paddingRight: '14px',
      position: 'absolute',
      bottom: '-20px',
    },
    '.MuiInputBase-root': {
      '&.Mui-error': {
        borderColor: 'error.main',
      }
    },
    '.MuiFilledInput-underline:after': {
      borderBottomColor: 'text.primary',
    },
    '.MuiFilledInput-underline.Mui-error:after': {
      borderBottomColor: 'error.main',
    },
    '.MuiFilledInput-root': {
      '&:before': {
        borderBottomColor: 'rgba(0, 0, 0, 0.42)',
      },
      '&:hover:not(.Mui-disabled):before': {
        borderBottomColor: 'rgba(0, 0, 0, 0.87)',
      },
    }
  }

  return (
    <Box sx={{ bgcolor: '#0d6efd', my: 5, mx: isMobile ? 2 : 10, p: 3, borderRadius: 5, display: 'flex', justifyContent: 'center', }}>
      <Box maxWidth={maxWidth} width="100%">
        <form onSubmit={formik.handleSubmit}>
          <Box textAlign="center" marginBottom={4}>
            <Typography variant="h5" color="white" fontWeight="bold">
              Subscribe To Our Newsletter
            </Typography>
          </Box>
          <Grid container spacing={2} justifyContent="center" alignItems="center">
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                id="name"
                name="name"
                label="Name"
                value={formik.values.name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.name && Boolean(formik.errors.name)}
                helperText={formik.touched.name && formik.errors.name}
                variant="filled"
                sx={textFieldStyle}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                id="email"
                name="email"
                label="Your email address"
                type="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
                variant="filled"
                sx={textFieldStyle}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <Button
                color="primary"
                variant="contained"
                fullWidth
                type="submit"
                sx={{ bgcolor: '#f39c12', '&:hover': { bgcolor: '#e67e22' }, color: 'white', borderRadius: 5 }}
              >
                Submit now
              </Button>
            </Grid>
          </Grid>
        </form>
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} message="Subscription successful!" />
      </Box>
    </Box>
  );
};

export default SubscriptionForm;